import Fluxible from 'vendor/cnpm/fluxible.v0-4/index';

import routes from 'bundles/admin-dashboard/routes';
import CourseCreationMessageStore from 'bundles/admin/components/course-creation/stores/CourseCreationMessageStore';
import CreateMessageParamsStore from 'bundles/enterprise-admin-messages/stores/CreateMessageParamsStore';
import CourseStore from 'bundles/in-course-stores/stores/CourseStore';
import NaptimeStore from 'bundles/naptimejs/stores/NaptimeStore';
import PaymentFormStore from 'bundles/payments-common/stores/PaymentFormStore';
import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';

import 'css!bundles/global-styles/global-element-styles';

const appEnv = new Fluxible({
  component: routes,
});

appEnv.registerStore(ApplicationStore);
appEnv.registerStore(NaptimeStore);
appEnv.registerStore(CourseStore);
appEnv.registerStore(CreateMessageParamsStore);
appEnv.registerStore(CourseCreationMessageStore);
appEnv.registerStore(PaymentFormStore);

export default appEnv;
